import {combineReducers} from "redux";
import clientSelectViewModel from "./clientSelectViewModel";

const rootViewModel = combineReducers({
    clientSelectViewModel,
});

export default rootViewModel;
